module.exports = __webpack_public_path__ + "static/media/shutterstock_116579431.b12212f4.jpg";